export enum BaseCheckboxColor {
  Cyan = 'cyan',
  Blue = 'blue',
  Red = 'red',
  PersianBlue = 'persianBlue',
}
